var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.4,5.6l-4-3.8C16,1.4,15.5,1.2,15,1.2H5c-1.1,0-2,0.9-2,2v17.6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V7 C21,6.5,20.8,6,20.4,5.6z M19,20.8H5V3.2h10L19,7V20.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,8.1H7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h5.2c0.6,0,1,0.4,1,1S13.3,8.1,12.8,8.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1,13H7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h8.6c0.6,0,1,0.4,1,1S16.7,13,16.1,13z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1,18.1H7.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h8.6c0.6,0,1,0.4,1,1S16.7,18.1,16.1,18.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.7639e13a8df44157a00fdd7d390b3308.svg";
export { ForwardRef as ReactComponent };